import React from 'react';
import HomeCompany from './Company';

const Home: React.FC = () => {
  return <HomeCompany />;
};

export default Home;
